"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const string_1 = require("../../helpers/string/string");
const Title_styled_1 = require("./Title.styled");
const Title = ({ className, text }) => (0, jsx_runtime_1.jsx)(Title_styled_1.TitleStyled, { className: (0, string_1.getClassName)('octo', className), children: (0, jsx_runtime_1.jsx)("span", { children: text }) });
exports.Title = Title;
//# sourceMappingURL=Title.js.map